import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const AddFromListIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7Z"
                fill={color}
            />
            <path
                d="M5 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11Z"
                fill={color}
            />
            <path
                d="M5 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15Z"
                fill={color}
            />
            <path
                d="M18 11C18.5523 11 19 11.4477 19 12V14H21C21.5523 14 22 14.4477 22 15C22 15.5523 21.5523 16 21 16H19V18C19 18.5523 18.5523 19 18 19C17.4477 19 17 18.5523 17 18V16H15C14.4477 16 14 15.5523 14 15C14 14.4477 14.4477 14 15 14H17V12C17 11.4477 17.4477 11 18 11Z"
                fill={color}
            />
        </svg>
    );
};
